module.exports = __webpack_public_path__ + "img/icon_sec3_1@2x.785575f9.png";